import React from "react";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { updateAppointment } from "../redux/slices/appointmentSlice";
import { AppDispatch } from "../redux/store";
import { AppointmentState } from "../types";
import { cardHeaderClass, cardBodyClass, textArea } from "css";
import { ApptType } from "types/booking-config.interface";

interface AppointmentSummaryProps {
  appointment: AppointmentState;
  selectedDate: string | null;
  selectedTime: string;
  stayOrDropOff: ApptType;
  setClear: (clear: boolean) => void;
}

export const AppointmentSummary: React.FC<AppointmentSummaryProps> = ({
  appointment,
  selectedDate,
  selectedTime,
  stayOrDropOff,
  setClear,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const onCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    if (e.target.value !== "" || !appointment.shopData?.requireComments) {
      dispatch(updateAppointment({ updates: { comments: e.target.value } }));
      setClear(true);
    } else {
      dispatch(updateAppointment({ updates: { comments: "" } }));
      setClear(false);
    }
  };

  const serviceDescription = appointment?.services?.length
    ? appointment?.services?.map((svc) => svc.name).join(", ")
    : appointment?.service;

  return (
    <div>
      <div
        id="appointment-summary"
        className={cardHeaderClass}
        style={{
          backgroundColor: appointment?.shopData?.color,
        }}
      >
        Appointment Summary
      </div>
      <div
        className={cardBodyClass}
        style={{
          borderColor: appointment?.shopData?.color,
        }}
      >
        <div className="pb-4">
          You've chosen to{" "}
          {stayOrDropOff.toLowerCase() === "wait" ? "stay with" : "drop off"}{" "}
          your{" "}
          <strong>
            {appointment?.vehicle?.year} {appointment?.vehicle?.make}{" "}
            {appointment?.vehicle?.model}
          </strong>{" "}
          for service related to <strong>{serviceDescription}</strong>.
          {appointment?.value === "9" &&
            " Please describe what we need to inspect in the addition comments box below."}
        </div>
        <div className="pb-4">
          The date and time of your service will be{" "}
          <strong>
            {selectedDate && dayjs(selectedDate).format("MM/DD/YYYY")} at{" "}
            {selectedTime}
          </strong>
        </div>
        <div>
          <strong>Additional Comments</strong>
          <span style={{ color: "red" }}>
            {appointment.shopData?.requireComments && " - required"}
          </span>
          <div>
            <textarea
              className={textArea}
              rows={4}
              placeholder="Enter any additional comments here..."
              onChange={onCommentChange}
              style={{
                color: "black",
                backgroundColor: "white",
                borderColor: appointment?.shopData?.color,
                outlineColor: appointment?.shopData?.color,
              }}
              defaultValue={appointment?.comments || ""}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};
